module.exports = __webpack_public_path__ + "img/bm-currency-guide.8c3179b2.png";